const onSetMenuActive = (activeMenuItem) => {
    return { activeMenuItem, activeSubMenuItem: '', type: 'SET_MENU_ACTIVE' }
}

const onSetSubMenuActive = (activeSubMenuItem) => {
    return { activeSubMenuItem, activeMenuItem: '', type: 'SET_SUB_MENU_ACTIVE' }
}

const onSetActiveSecondarySidebar = (activeSecondarySidebar) => {
    return { activeSecondarySidebar, type: 'SET_ACTIVE_SECONDARY_SIDERBAR' }
}

export default {
    onSetMenuActive,
    onSetSubMenuActive,
    onSetActiveSecondarySidebar
}
